import React from "react";
import classNames from 'classnames';

import { connect } from 'react-redux'; 
import {overrideEligibleStatus} from '../../redux/actions/orderAction'

class OrderHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            storeClerkToken: window.sessionStorage.getItem('storeClerkToken'),
            storeClerk: window.sessionStorage.getItem('storeClerk'),
            storeId: window.sessionStorage.getItem('storeId'),
            orderBillInfo: [],
            orderShipInfo: [],
            orderInfo: [],
        }
        this.overrideEligibility = this.overrideEligibility.bind(this);
    }

    // override the eligibility status by store clerk
    overrideEligibility() {     
     
       let overrideInput = {"orderIdentifier":this.state.orderInfo.orderId,
                            "overriddenBy" : this.state.storeClerk,
                            "email":this.state.orderBillInfo.customerEmailId,
                            "storeClerkToken":this.state.storeClerkToken,
                            "storeId":this.state.storeId
                            }
        this.props.overrideEligibleStatus(overrideInput,this.props);           
    }

    
    componentWillMount() {    

        if(this.props.orderDetails){
            if (this.props.orderDetails.billInfoMap) {
                this.setState({
                    orderBillInfo: this.props.orderDetails.billInfoMap
                });
            }
            if (this.props.orderDetails.shipInfoMap) {
                this.setState({
                    orderShipInfo: this.props.orderDetails.shipInfoMap
                });
            }
            if (this.props.orderDetails.orderMap) {
                this.setState({
                    orderInfo: this.props.orderDetails.orderMap,
                });
            } 
        }

            if (this.props.policyData) {
                this.setState({
                    policyData: this.props.policyData,
                }); 
        } 
    }

    //update the state value
    componentWillReceiveProps(nextProps){
        
        if(nextProps.orderDetails){
            if (nextProps.orderDetails.orderMap) {
                this.setState({
                    orderInfo: nextProps.orderDetails.orderMap,
                });
            } 
        } 
    }
    

    render() {

        let EligibleStatusClasses = classNames({
            'info-box': true, ' black-bg': this.state.storeClerkToken ? false : true
        });

        // Order Header Block
        let orderHead = (<div className="orderdetail-title">
                          ORDER  #{this.state.orderInfo.orderId}
                            <div>
                              <small>{this.state.orderInfo.orderPlacedDateAndTime}</small>
                           </div>
                        </div>)

        // Billing Info Block
        let billing = (<div className="col">
                         <div className="orderdetail-sub-title">BILLING</div>
                          <ul className="order-details-list">
                            <li> {this.state.orderBillInfo.customerFirstName} {this.state.orderBillInfo.customerLastName}</li>
                            <li> {this.state.orderBillInfo.customerEmailId}</li>
                          </ul>
                      </div>)

        //  Shipping Info Block
        let shipping = (<div className="col">
                          <div className="orderdetail-sub-title">SHIPPING</div>
                           <ul className="order-details-list">
                            <li>{this.state.orderShipInfo.name}</li>
                            <li>{this.state.orderShipInfo.address1}</li>
                            <li>{this.state.orderShipInfo.address2}</li>
                            <li>{this.state.orderShipInfo.city}, {this.state.orderShipInfo.state} {this.state.orderShipInfo.postalCode} {this.state.orderShipInfo.country}</li>
                            <li>{this.state.orderShipInfo.telecomNumber} </li>
                           </ul>
                       </div>)
        return (
            
            <React.Fragment>
                {orderHead}
                <div className="row">
                    {billing}
                    {shipping}

                    <div className="col">
                        <div className="orderdetail-sub-title">ELIGIBLE FOR RETURNS</div>
                        <ul className="order-details-list">
                            <li>{(((this.state.orderInfo.orderEligibility &&  !this.state.orderInfo.atLeastOneItemIneligibleForReturn) || this.state.orderInfo.eligibilityOverriden) || this.state.orderInfo.atleastOneProdEligForReturn)  ? 'Yes' : 'No'}</li>
                        </ul>

                        {(this.state.policyData && (this.state.orderInfo.atLeastOneItemIneligibleForReturn && !this.state.orderInfo.eligibilityOverriden))?
                            <React.Fragment>
                                {this.state.policyData.returnSettingsMap &&
                                <React.Fragment>
                                    {((this.state.policyData.returnSettingsMap.ineligibleReturnText && !this.state.orderInfo.atleastOneProdEligForReturn) && this.state.orderInfo.atleastOneNotFinalSale) &&
                                        <div className={EligibleStatusClasses}>
                                            <div dangerouslySetInnerHTML={{ __html: this.state.policyData.returnSettingsMap.ineligibleReturnText }} />
                                        </div>
                                    }
                                </React.Fragment>
                                }
                                {/* check the user to allow override option */}
                                {(this.state.storeClerkToken && !((this.state.orderInfo.orderEligibility &&  !this.state.orderInfo.atLeastOneItemIneligibleForReturn) || this.state.orderInfo.eligibilityOverriden)) &&
                                    <div className="float-right mt-20">
                                        <button data-toggle="modal" data-target="#confirm-delete" type="submit" className="btn btn-primary btn-new">OVERRIDE</button>
                                    </div> 
                                }                               
                            </React.Fragment> 
                             :
                             <div></div>
                        }

                    </div>
                </div>

                    <div className="modal fade" id="confirm-delete" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                            
                                <div className="modal-header">
                                    <div className="p-sub-title">CONFIRM OVERRIDE</div>
                                    <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                                 </div>
                              
                            
                                <div className="modal-body">
                                    <p>You are about to override the store return policy.  Please confirm this action.</p>
                                    <p className="debug-url"></p>
                                </div>
                                
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
                                    <a  data-dismiss="modal" onClick={this.overrideEligibility} className="btn btn-ok">Confirm</a>
                                </div>
                            </div>
                        </div>
                    </div>
 
            </React.Fragment>

        );
    }

} 

const mapStateToProps = (state) => ({
    policyData: state.storeSettingData.storeDesign,
    orderDetails: state.orderDataDetails.orderData
});

export default connect(mapStateToProps, {overrideEligibleStatus})(OrderHeader);  



// WEBPACK FOOTER //
// ./src/components/OrderDetails/OrderHeader.js